module.exports = __webpack_public_path__ + "efa539c93975dfe5e725db67fb116df9.png";